import React from 'react';
import Configurator from 'bookingbug-configurator-js';
import Spinner from 'react-spinner-material';
import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  loader: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'white',
    backdropFilter: 'blur(4px)',
    opacity: 0.85,
    zIndex: 10000,
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const Loader = ({ visible }) => {
  const { colors } = Configurator.getConfig('branding');
  const { loader } = useStyle();

  if (!visible) return false;

  return (
    <div className={loader}>
      <Spinner size={100} spinnerColor={colors.primary} spinnerWidth={5} visible />
    </div>
  );
};

export default Loader;
